export enum RejectEmailOptions {
  INCORRECT_INFO = 'incorrect_info',
  NOT_RELEVANT = 'not_relevant',
  TECH_ISSUES = 'tech_issues',
  USE_DIFFERENT_CHANNEL = 'use_different_channel',
  OTHER = 'other',
}

export enum EditRequestEmailOptions {
  REVIEW_AFTER_EDITS = 'review_after_edits',
  AUTO_PUBLISH = 'auto_publish',
}
